import { render, staticRenderFns } from "./RptBasicReport.vue?vue&type=template&id=f98cf0b0&scoped=true&"
import script from "./RptBasicReport.vue?vue&type=script&lang=js&"
export * from "./RptBasicReport.vue?vue&type=script&lang=js&"
import style0 from "./RptBasicReport.vue?vue&type=style&index=0&id=f98cf0b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98cf0b0",
  null
  
)

export default component.exports